import en from '@gasbi/localizations/en.json';
import ua from '@gasbi/localizations/ua.json';

export const LOCALE_NS = 'organization';

export const locales = {
  ua: { [LOCALE_NS]: ua },
  en: { [LOCALE_NS]: en },
};

const lng = 'ua';
const supportedLangs = ['ua', 'en', 'uk'];
const fallbackLng = 'uk';
const defaultNS = LOCALE_NS;

export const i18nInstanceOptions = {
  locales,
  lng,
  supportedLangs,
  fallbackLng,
  defaultNS,
};
